import React, { useRef, useState, useEffect } from "react";
import { gsap } from "gsap";
import { Link } from "react-router-dom";
import { Container, Col, Row, Nav, Tab } from "react-bootstrap";
import FsLightbox from "fslightbox-react";
import Select from "react-select";
import { useSelector } from "react-redux";
import axios from "axios";
import { CompactWatchlistButtons } from "../../../components/WatchlistButtons";

// img
import logo from "../../../assets/images/logo.png";
import icon from "../../../assets/video/trailer.mp4";

// favorite img

// parallax
import parallax3 from "../../../assets/images/parallax/p1.jpg";
import parallax4 from "../../../assets/images/parallax/parallax-logo.png";

// trending
import trending1 from "../../../assets/images/trending/01.jpg";
import trending01 from "../../../assets/images/trending/011.jpg";
import trending2 from "../../../assets/images/trending/02.jpg";
import tranding02 from "../../../assets/images/trending/trending013.jpg";
import trending3 from "../../../assets/images/trending/03.jpg";
import tranding03 from "../../../assets/images/trending/trending012.jpg";
import trending4 from "../../../assets/images/trending/04.jpg";
import trending5 from "../../../assets/images/trending/05.jpg";
import trending6 from "../../../assets/images/trending/06.jpg";
import trendinglabel from "../../../assets/images/trending/trending-label.png";
import tranding04 from "../../../assets/images/trending/tranding04.jpg";
import tranding05 from "../../../assets/images/trending/tranding05.jpg";

import smalllogo1 from "../../../assets/images/trending/72-72-01.jpg";
import smalllogo4 from "../../../assets/images/trending/72-72-04.jpg";
import smalllogo2 from "../../../assets/images/trending/72-72-02.jpg";
import smalllogo3 from "../../../assets/images/trending/72-72-03.jpg";
import smalllogo5 from "../../../assets/images/trending/72-72-05.jpg";

// episodes
import episodes1 from "../../../assets/images/episodes/01.jpg";
import episodes2 from "../../../assets/images/episodes/02.jpg";
import episodes3 from "../../../assets/images/episodes/03.jpg";
import episodes4 from "../../../assets/images/episodes/04.jpg";
import episodes5 from "../../../assets/images/episodes/05.jpg";

// slice
import { getAllModes } from "../../../store/redux/SLICE/auth/ModeSlice";
import { getAllContentThunk } from "../../../store/redux/SLICE/content/Content";
import { BASE_URL } from "../../../BaseUrl";

import { useDispatch } from "react-redux";

import {
  LatestMovies,
  upcomingData,
  Suggested,
  options1,
  options2,
  Recommended,
  familiarFavorites,
} from "./../dummyData/homeDummyData";

// swiper                                                                                                                                                                                                                                                                                                               c c v cv cv cvcvcvvcc vccvcvvcvc    ccv cv cvccvcvvvc   vcvc      cv                                                                          ccv
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { EffectFade, Navigation, Thumbs, Pagination } from "swiper";
import "swiper/swiper-bundle.css";
import { Top10ShowsInUS } from "../dummyData/newAndPopularData";
import { toast } from "react-toastify";
import { TMDB_CONFIG, getImageUrl, getPosterUrl, buildApiUrl } from "../../../config/tmdb";
import "../../../assets/css/home-section-sizing.css";

SwiperCore.use([EffectFade, Navigation, Thumbs, Pagination]);

// TMDB API Service
const fetchUpcomingMovies = async () => {
  try {
    // Check if JWT token is configured
    if (TMDB_CONFIG.JWT_TOKEN === 'YOUR_TMDB_JWT_TOKEN') {
      throw new Error('TMDB JWT token not configured. Please add your JWT token to the environment variables or config file.');
    }

    const url = `${TMDB_CONFIG.BASE_URL}${TMDB_CONFIG.ENDPOINTS.UPCOMING_MOVIES}?language=en-US&page=1`;

    const options = {
      method: 'GET',
      url: url,
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${TMDB_CONFIG.JWT_TOKEN}`
      }
    };

    const response = await axios.request(options);
    return response.data;
  } catch (error) {
    console.error('Error fetching TMDB data:', error);
    throw error;
  }
};

// TMDB Trending API Service
const fetchTrendingData = async () => {
  try {
    // Check if JWT token is configured
    if (TMDB_CONFIG.JWT_TOKEN === 'YOUR_TMDB_JWT_TOKEN') {
      throw new Error('TMDB JWT token not configured. Please add your JWT token to the environment variables or config file.');
    }

    const url = `${TMDB_CONFIG.BASE_URL}/trending/all/day?language=en-US`;

    const options = {
      method: 'GET',
      url: url,
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${TMDB_CONFIG.JWT_TOKEN}`
      }
    };

    const response = await axios.request(options);
    return response.data;
  } catch (error) {
    console.error('Error fetching TMDB trending data:', error);
    throw error;
  }
};

// Transform TMDB data to match component structure
const transformTMDBData = (tmdbMovies) => {
  return tmdbMovies.results.map(movie => ({
    _id: movie.id.toString(),
    title: movie.title,
    contentName: movie.title,
    description: movie.overview,
    thumbnail_image: getImageUrl(movie.backdrop_path),
    poster_image: getPosterUrl(movie.poster_path),
    release_date: movie.release_date,
    vote_average: movie.vote_average,
    vote_count: movie.vote_count,
    adult: movie.adult,
    genre_ids: movie.genre_ids,
    original_language: movie.original_language,
    original_title: movie.original_title,
    popularity: movie.popularity,
    video: movie.video,
    // Add default values for fields that might not exist in TMDB
    Artist: [], // Will be populated separately if needed
    Genres: [], // Will be populated separately if needed
    Themes: [], // Will be populated separately if needed
    ageLimit: movie.adult ? '18+' : '13+',
    duration: '2:30', // Default duration as TMDB doesn't provide runtime in upcoming movies
    trailer: [] // Will be populated separately if needed
  }));
};

// Transform TMDB trending data to match original component structure
const transformTrendingData = (trendingData) => {
  return trendingData.results.map(item => {

    return {
      _id: item.id.toString(),
      title: item.title || item.name,
      contentName: item.title || item.name,
      description: item.overview,
      // Use original structure for images
      imageUrl: item.poster_path ? `https://image.tmdb.org/t/p/w500${item.poster_path}` : 'https://via.placeholder.com/300x450/333/fff?text=No+Image',
      topImg: `https://via.placeholder.com/50x50/333/fff?text=${item.id}`, // For numbered badges
      // Original structure fields
      ageRating: item.adult ? '18+' : '13+',
      duration: item.media_type === 'tv' ? '45 min' : '2h 30m',
      // Additional TMDB fields
      release_date: item.release_date || item.first_air_date,
      vote_average: item.vote_average,
      vote_count: item.vote_count,
      adult: item.adult,
      genre_ids: item.genre_ids,
      original_language: item.original_language,
      original_title: item.original_title || item.original_name,
      popularity: item.popularity,
      video: item.video,
      media_type: item.media_type, // 'movie' or 'tv'
      // Legacy fields for compatibility
      Artist: [],
      Genres: [],
      Themes: [],
      trailer: []
    };
  });
};

// TMDB Latest Movie API Service - Using Now Playing Movies
const fetchLatestMovie = async () => {
  try {
    // Check if JWT token is configured
    if (TMDB_CONFIG.JWT_TOKEN === 'YOUR_TMDB_JWT_TOKEN') {
      throw new Error('TMDB JWT token not configured. Please add your JWT token to the environment variables or config file.');
    }

    const options = {
      method: 'GET',
      url: 'https://api.themoviedb.org/3/movie/now_playing?language=en-US&page=1',
      headers: {
        accept: 'application/json',
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
      }
    };

    const response = await axios.request(options);
    console.log("🎬 Now Playing Movies Response:", response.data);
    
    // Get the first movie from now playing movies
    if (response.data.results && response.data.results.length > 0) {
      const firstMovie = response.data.results[0];
      console.log("🎯 Selected Latest Movie:", firstMovie);
      return firstMovie;
    } else {
      throw new Error('No movies found in now playing list');
    }
  } catch (error) {
    console.error('Error fetching TMDB latest movie:', error);
    throw error;
  }
};

const gsapAnimate = {
  getData: (elem) => {
    const option = {
      opacity: 0,
      scale: 1,
      position: {
        x: 0,
        y: 0,
      },
      ease: "",
      duration: 1,
      delay: 0.4,
      rotate: 0,
    };
    if (elem !== undefined) {
      option.position.x = gsapAnimate.validValue(elem.dataset.iqPositionX, 0);

      option.position.y = gsapAnimate.validValue(elem.dataset.iqPositionY, 0);

      option.rotate = gsapAnimate.validValue(elem.dataset.iqRotate, 0);

      option.scale = gsapAnimate.validValue(elem.dataset.iqScale, 1);

      option.opacity = gsapAnimate.validValue(elem.dataset.iqOpacity, 0);

      option.delay = gsapAnimate.validValue(elem.dataset.iqDelay, 0.4);

      option.duration = gsapAnimate.validValue(elem.dataset.iqDuration, 1.5);

      option.ease = gsapAnimate.validValue(elem.dataset.iqEase, "");

      const setOption = {
        opacity: option.opacity,
        scale: option.scale,
        x: option.position.x,
        y: option.position.y,
        ease: option.ease,
        rotate: option.rotate,
        duration: option.duration,
        delay: option.delay,
      };

      return setOption;
    } else {
      return { opacity: 0 };
    }
  },
  onStart: (elem) => {
    const setOption = gsapAnimate.getData(elem);

    gsap.from(elem, setOption);
  },

  onEnd: (elem) => {
    const setOption = gsapAnimate.getData(elem);

    gsap.to(elem, setOption);
  },

  onStartEnd: (elem) => {
    const setOption = gsapAnimate.getData(elem);

    const setEndOption = gsapAnimate.getData(elem);

    setEndOption.opacity = 1;

    setEndOption.x = 0;

    setEndOption.y = 0;

    setEndOption.rotate = 0;

    setEndOption.scale = 1;

    gsap.fromTo(elem, setOption, setEndOption);
  },
  validValue: (attr, defaultVal) => {
    if (attr !== undefined && attr !== null) {
      return Number(attr);
    }
    return Number(defaultVal);
  },
};

const Homepage = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [toggler1] = useState(false);
  const [toggler2] = useState(false);
  const [toggler3] = useState(false);
  // const [isVideoVisible, setIsVideoVisible] = useState(false);
  const videoRef = useRef(null);
  const modedAta = useSelector((state) => state.modedAta);
  const contentData = useSelector((state) => state.content);
  const contentsData = useSelector((state) => state.contents);

  // Get the currently selected profile from localStorage
  const [selectedProfile, setSelectedProfile] = useState(() => {
    const stored = localStorage.getItem("selectedProfile");
    return stored ? JSON.parse(stored) : null;
  });

  // TMDB API state management
  const [tmdbData, setTmdbData] = useState({
    movies: [],
    loading: false,
    error: null
  });

  // TMDB Trending API state management
  const [trendingData, setTrendingData] = useState({
    movies: [],
    tvShows: [],
    loading: false,
    error: null
  });

  // TMDB Upcoming Movies Section state management
  const [upcomingMoviesSection, setUpcomingMoviesSection] = useState({
    movies: [],
    loading: false,
    error: null
  });

  // Selected section (Suggested For You) trending state
  const [selectedTrending, setSelectedTrending] = useState({
    movies: [],
    tvShows: [],
    loading: false,
    error: null
  });

  // Selected trending TV show state
  const [selectedTrendingTVShow, setSelectedTrendingTVShow] = useState(null);
  const [swiperInstance, setSwiperInstance] = useState(null);
  // Active tab state for trending section
  const [activeTrendingTab, setActiveTrendingTab] = useState("trending-data1");

  // Latest Movie state for parallax section
  const [latestMovie, setLatestMovie] = useState({
    movie: null,
    loading: false,
    error: null
  });

  console.log(modedAta);

  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  const handleTrendingTVShowSelect = (swiper) => {
    if (trendingData.tvShows && trendingData.tvShows.length > 0) {
      const realIndex = swiper.realIndex;
      const activeShow = trendingData.tvShows.slice(0, 6)[realIndex % 6];
      setSelectedTrendingTVShow(activeShow);
      setActiveTrendingTab("trending-data1"); // Reset to Overview tab
    }
  };

  useEffect(() => {
    if (trendingData.tvShows && trendingData.tvShows.length > 0 && !selectedTrendingTVShow) {
      setSelectedTrendingTVShow(trendingData.tvShows[0]);
    }
  }, [trendingData.tvShows]);
  // const handleTrendingTVShowSelect = (tvShow) => {

  //   setSelectedTrendingTVShow(tvShow);
  //   // Reset to Overview tab when new TV show is selected
  //   setActiveTrendingTab("trending-data1");
  // };

  const handleAddClick = (Data) => {
    toast.success(Data, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  // Fetch Trending Movies and TV for selected section
  const fetchSelectedTrending = async () => {
    setSelectedTrending(prev => ({ ...prev, loading: true, error: null }));
    try {
      const movieOptions = {
        method: 'GET',
        url: 'https://api.themoviedb.org/3/trending/movie/day?language=en-US',
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };

      const tvOptions = {
        method: 'GET',
        url: 'https://api.themoviedb.org/3/trending/tv/day?language=en-US',
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };

      const [moviesRes, tvRes] = await Promise.all([
        axios.request(movieOptions),
        axios.request(tvOptions)
      ]);

      const movies = (moviesRes.data.results || []).slice(0, 10).map(movie => ({
        title: movie.title,
        image: movie.poster_path ? `https://image.tmdb.org/t/p/w500${movie.poster_path}` : 'https://via.placeholder.com/300x450/333/fff?text=No+Image',
        ageRating: movie.adult ? '18+' : '13+',
        duration: '2h 30m'
      }));

      const tvShows = (tvRes.data.results || []).slice(0, 10).map(tv => ({
        title: tv.name,
        image: tv.poster_path ? `https://image.tmdb.org/t/p/w500${tv.poster_path}` : 'https://via.placeholder.com/300x450/333/fff?text=No+Image',
        ageRating: tv.adult ? '18+' : '13+',
        duration: '45 min'
      }));

      setSelectedTrending({ movies, tvShows, loading: false, error: null });
    } catch (error) {
      console.error('Failed to fetch selected trending content:', error);
      setSelectedTrending(prev => ({ ...prev, loading: false, error: error.message || 'Failed to load trending content' }));
    }
  };




  const copyURL = () => {
    const url = window.location.href;
    const tempInput = document.createElement("input");
    document.body.appendChild(tempInput);
    tempInput.value = url;
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    toast.success("URL copied to clipboard: " + url)

  };


  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {
        // Handle any errors that occur during playback
        console.error("Error playing video:", error);
      });
    }
  }, []);

  // Update selected profile when localStorage changes
  useEffect(() => {
    const handleStorageChange = () => {
      const stored = localStorage.getItem("selectedProfile");
      if (stored) {
        setSelectedProfile(JSON.parse(stored));
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);



  const animationInit = () => {
    if (
      document.querySelector(".swiper-container .swiper-slide-active") !== null
    ) {
      const gsapElem = document
        .querySelector(".swiper-container .swiper-slide-active")
        .querySelectorAll('[data-iq-gsap="onStart"]');

      Array.from(gsapElem, (elem) => {
        return gsapAnimate.onStartEnd(elem);
      });
    }
  };

  const dispatch = useDispatch();

  const GetAllMode = () => {
    dispatch(getAllModes());
  };

  const GetAllContent = () => {
    console.log("Calling GetAllContent API...");
    dispatch(getAllContentThunk({ page_no: 1, page_size: 11 }));
  };

  // Fetch TMDB upcoming movies
  const fetchTMDBMovies = async () => {
    setTmdbData(prev => ({ ...prev, loading: true, error: null }));
    try {
      const data = await fetchUpcomingMovies();
      const transformedData = transformTMDBData(data);
      setTmdbData({
        movies: transformedData,
        loading: false,
        error: null
      });
      console.log("TMDB Movies fetched:", transformedData);
    } catch (error) {
      setTmdbData(prev => ({
        ...prev,
        loading: false,
        error: error.message
      }));
      console.error("Failed to fetch TMDB movies:", error);
    }
  };

  // Fetch Latest Movie for Parallax Section
  const fetchLatestMovieData = async () => {
    console.log("🚀 Starting to fetch latest movie data...");
    setLatestMovie(prev => ({ ...prev, loading: true, error: null }));
    try {
      console.log("📡 Calling fetchLatestMovie API...");
      const data = await fetchLatestMovie();
      console.log("✅ Raw latest movie data received:", data);
      
      // Transform the latest movie data with better fallbacks
      const transformedMovie = {
        id: data.id || Math.floor(Math.random() * 1000000),
        title: data.title || data.original_title || "Latest Movie",
        overview: data.overview || "Experience the latest blockbuster movie with stunning visuals and captivating storytelling.",
        release_date: data.release_date || new Date().toISOString().split('T')[0],
        vote_average: data.vote_average || 7.5,
        vote_count: data.vote_count || 1000,
        adult: data.adult || false,
        backdrop_path: data.backdrop_path,
        poster_path: data.poster_path,
        runtime: data.runtime || 120,
        genres: data.genre_ids || [],
        // Image URLs with better fallbacks
        backdrop_url: data.backdrop_path 
          ? `https://image.tmdb.org/t/p/w1280${data.backdrop_path}` 
          : parallax3,
        poster_url: data.poster_path 
          ? `https://image.tmdb.org/t/p/w500${data.poster_path}` 
          : parallax4,
        // Formatted data
        ageRating: data.adult ? '18+' : '13+',
        duration: data.runtime 
          ? `${Math.floor(data.runtime / 60)}h ${data.runtime % 60}m` 
          : '2h 30m',
        year: data.release_date 
          ? data.release_date.substring(0, 4) 
          : new Date().getFullYear().toString(),
        rating: data.vote_average 
          ? data.vote_average.toFixed(1) 
          : '7.5'
      };

      console.log("🔄 Transformed movie data:", transformedMovie);

      setLatestMovie({
        movie: transformedMovie,
        loading: false,
        error: null
      });
      
      console.log("✅ Latest Movie state updated successfully!");
    } catch (error) {
      console.error("❌ Failed to fetch latest movie:", error);
      setLatestMovie(prev => ({
        ...prev,
        loading: false,
        error: error.message || "Failed to fetch latest movie"
      }));
    }
  };

  // Fetch TMDB trending data
  const fetchTrendingMovies = async () => {
    setTrendingData(prev => ({ ...prev, loading: true, error: null }));
    try {
      const data = await fetchTrendingData();
      console.log("Raw TMDB trending data:", data);

      const transformedData = transformTrendingData(data);
      console.log("Transformed trending data:", transformedData);

      // Separate movies and TV shows
      const movies = transformedData.filter(item => item.media_type === 'movie');
      const tvShows = transformedData.filter(item => item.media_type === 'tv');

      console.log("Filtered movies:", movies);
      console.log("Filtered TV shows:", tvShows);

      setTrendingData({
        movies: movies,
        tvShows: tvShows,
        loading: false,
        error: null
      });
      console.log("TMDB Trending data fetched successfully:", { movies, tvShows });
    } catch (error) {
      setTrendingData(prev => ({
        ...prev,
        loading: false,
        error: error.message || "Failed to fetch trending data"
      }));
      console.error("Failed to fetch TMDB trending data:", error);
    }
  };

  // Fetch TMDB upcoming movies for the upcoming movies section
  const fetchUpcomingMoviesSection = async () => {
    setUpcomingMoviesSection(prev => ({ ...prev, loading: true, error: null }));
    try {
      const options = {
        method: 'GET',
        url: 'https://api.themoviedb.org/3/movie/upcoming?language=en-US&page=1',
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };

      const response = await axios.request(options);
      const transformedData = response.data.results.map(movie => ({
        title: movie.title,
        imageUrl: movie.poster_path ? `https://image.tmdb.org/t/p/w500${movie.poster_path}` : 'https://via.placeholder.com/300x450/333/fff?text=No+Image',
        ageRating: movie.adult ? '18+' : '13+',
        duration: '2h 30m' // Default duration as TMDB doesn't provide runtime in upcoming movies
      }));

      setUpcomingMoviesSection({
        movies: transformedData,
        loading: false,
        error: null
      });
      console.log("TMDB Upcoming Movies Section fetched:", transformedData);
    } catch (error) {
      setUpcomingMoviesSection(prev => ({
        ...prev,
        loading: false,
        error: error.message || "Failed to fetch upcoming movies"
      }));
      console.error("Failed to fetch TMDB upcoming movies:", error);
    }
  };

  useEffect(() => {
    GetAllMode();
  }, []);

  useEffect(() => {
    GetAllContent();
  }, []);

  useEffect(() => {
    fetchTMDBMovies();
    fetchTrendingMovies();
    fetchUpcomingMoviesSection();
    fetchSelectedTrending();
    fetchLatestMovieData();
  }, []);

  // Debug: Log content data
  useEffect(() => {
    console.log("Content Data (new):", contentData);
    console.log("Contents Data (old):", contentsData);
    console.log("Content Loading:", contentData.loading);
    console.log("Content Array:", contentData.content);
    console.log("Contents Array:", contentsData.contents);
  }, [contentData, contentsData]);

  // Debug: Log trending data
  useEffect(() => {
    console.log("Trending Data State:", trendingData);
    console.log("Trending Movies Count:", trendingData.movies?.length || 0);
    console.log("Trending TV Shows Count:", trendingData.tvShows?.length || 0);
  }, [trendingData]);

  // Debug: Log selected trending TV show
  useEffect(() => {
    console.log("Selected Trending TV Show State:", selectedTrendingTVShow);
    if (selectedTrendingTVShow) {
      console.log("Selected TV Show Details:");
      console.log("- Title:", selectedTrendingTVShow.title);
      console.log("- Description:", selectedTrendingTVShow.description);
      console.log("- Image URL:", selectedTrendingTVShow.imageUrl);
      console.log("- Release Date:", selectedTrendingTVShow.release_date);
      console.log("- Vote Average:", selectedTrendingTVShow.vote_average);
    }
  }, [selectedTrendingTVShow]);

  // Debug: Log latest movie state
  useEffect(() => {
    console.log("🎬 Latest Movie State:", latestMovie);
    if (latestMovie.movie) {
      console.log("Latest Movie Details:");
      console.log("- Title:", latestMovie.movie.title);
      console.log("- ID:", latestMovie.movie.id);
      console.log("- Rating:", latestMovie.movie.rating);
      console.log("- Overview:", latestMovie.movie.overview);
    }
  }, [latestMovie]);

  return (
    <>
      {/* Profile Display Banner - Removed as requested */}

      <FsLightbox
        toggler={toggler1}
        sources={[
          <iframe
            src={icon}
            title=" "
            width="100vw"
            height="100vh"
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
          />,
        ]}
      />

      <FsLightbox
        toggler={toggler2}
        sources={[
          <iframe
            src={icon}
            title=" "
            width="500px"
            height="200px"
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
          />,
        ]}
      />
      <FsLightbox
        toggler={toggler3}
        sources={[
          <iframe
            src={icon}
            title=" "
            width="500px"
            height="200px"
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
          />,
        ]}
      />
      {/* DYNAMIC CONTENT SECTION - RENDERS DATA FROM API */}
      <section id="home" className="iq-main-slider p-0 iq-rtl-direction">
        <div id="prev5" className="swiper-button swiper-button-prev">
          <i className="fa fa-chevron-left"></i>
        </div>
        <div id="next5" className="swiper-button swiper-button-next">
          <i className="fa fa-chevron-right"></i>
        </div>

        {tmdbData.loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: '500px' }}>
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : tmdbData.error ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: '500px' }}>
            <div className="text-center">
              <h3 className="text-white">Error Loading Movies</h3>
              <p className="text-white-50">{tmdbData.error}</p>
              <button
                className="btn btn-primary mt-3"
                onClick={fetchTMDBMovies}
              >
                Retry
              </button>
            </div>
          </div>
        ) : tmdbData.movies && tmdbData.movies.length > 0 ? (
          <Swiper
            navigation={{
              prevEl: "#prev5",
              nextEl: "#next5",
            }}
            pagination={{
              clickable: true,
            }}
            onInit={() => {
              animationInit();
            }}
            onSlideChangeTransitionStart={() => animationInit()}
            loop={true}
            id="home-slider"
            className="slider m-0 p-0"
          >
            {tmdbData.movies.map((item, index) => (
              <SwiperSlide key={item._id || index} className="slide slick-bg s-bg-1" style={{ position: 'relative' }}>
                {/* Background Video/Image */}
                {item.trailer && item.trailer.length > 0 ? (
                  <video
                    ref={videoRef}
                    id="background-video"
                    autoPlay
                    loop
                    volume={0.5}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      height: '100%',
                      width: '100%',
                      objectFit: 'cover',
                      zIndex: 1
                    }}
                  >
                    <source
                      src={`${BASE_URL}/assets/trailers/${item.trailer[0].path}`}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <div
                    className="bg-image"
                    style={{
                      backgroundImage: `url(${item.thumbnail_image || 'https://via.placeholder.com/1920x1080/333/fff?text=No+Image'})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      backgroundColor: '#333',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      height: '100%',
                      width: '100%',
                      zIndex: 1
                    }}
                  />
                )}

                <Container fluid className="position-relative h-100" style={{ zIndex: 2 }}>
                  <div className="slider-inner h-100">
                    <Row className="align-items-center iq-ltr-direction h-100">
                      <Col xl="6" lg="12" md="12">
                        <h1
                          className="slider-text big-title title text-uppercase"
                          data-iq-gsap="onStart"
                          data-iq-position-x="-200"
                        >
                          {item.title || item.contentName || 'Untitled'}
                        </h1>

                        <div className="d-flex flex-wrap align-items-center">
                          <div
                            className="slider-ratting d-flex align-items-center mr-4 mt-2 mt-md-3"
                            data-iq-gsap="onStart"
                            data-iq-position-x="-200"
                            data-iq-delay="-0.5"
                          >
                            <ul className="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left">
                              <li><i className="fa fa-star" aria-hidden="true"></i></li>
                              <li><i className="fa fa-star" aria-hidden="true"></i></li>
                              <li><i className="fa fa-star" aria-hidden="true"></i></li>
                              <li><i className="fa fa-star" aria-hidden="true"></i></li>
                              <li><i className="fa fa-star-half" aria-hidden="true"></i></li>
                            </ul>
                            <span className="text-white ml-2">{item.vote_average ? item.vote_average.toFixed(1) : 'N/A'}(TMDB)</span>
                          </div>
                          <div
                            className="d-flex align-items-center mt-2 mt-md-3"
                            data-iq-gsap="onStart"
                            data-iq-position-x="-200"
                            data-iq-delay="-0.5"
                          >
                            <span className="badge badge-secondary p-2">{item.ageLimit || '18+'}</span>
                            <span className="ml-3">{item.duration || '2:30'}</span>
                          </div>
                          <p
                            data-iq-gsap="onStart"
                            data-iq-position-y="80"
                            data-iq-delay="0.8"
                          >
                            {item.description || 'No description available.'}
                          </p>
                        </div>

                        <div
                          className="trending-list"
                          data-wp_object-in="fadeInUp"
                          data-delay-in="1.2"
                        >
                          {item.Artist && item.Artist.length > 0 && (
                            <div className="text-primary title starring">
                              Starring: <span className="text-body">{item.Artist.join(', ')}</span>
                            </div>
                          )}
                          {item.Genres && item.Genres.length > 0 && (
                            <div className="text-primary title genres">
                              Genres: <span className="text-body">{item.Genres.join(', ')}</span>
                            </div>
                          )}
                          {item.Themes && item.Themes.length > 0 && (
                            <div className="text-primary title tag">
                              Themes: <span className="text-body">{item.Themes.join(', ')}</span>
                            </div>
                          )}
                        </div>

                        <div
                          className="d-flex align-items-center r-mb-23"
                          data-iq-gsap="onStart"
                          data-iq-position-y="80"
                          data-iq-delay="0.8"
                        >
                          <Link
                            to={`/movie-details/${item._id}`}
                            className="btn btn-hover iq-button"
                            onClick={handleLinkClick}
                          >
                            <i className="fa fa-play mr-2" aria-hidden="true"></i>
                            Play Now
                          </Link>
                          <Link to={`/movie-details/${item._id}`} className="btn btn-link">
                            More details
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Container>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="d-flex justify-content-center align-items-center" >
            <div className="text-center">
              <h3 className="text-white">No Content Available</h3>
              <p className="text-white-50">Please check back later for new content.</p>
            </div>
          </div>
        )}
      </section>

      <div className="main-content">
        {/* Top 10 movie in US */}
        <section id="iq-top-movies">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between ">
                  <h4 className="main-title mb-3">Trending Movies</h4>
                  <Link className="iq-view-all" to="/view-all-movies/trending" onClick={handleLinkClick}>
                    View All
                  </Link>
                </div>
                <div id="favorites-contens">
                  <div
                    id="prev-top-movies"
                    className="swiper-button swiper-button-prev"
                  >
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div
                    id="next-top-movies"
                    className="swiper-button swiper-button-next"
                  >
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    breakpoints={{
                      320: { slidesPerView: 1, spaceBetween: 10 },
                      480: { slidesPerView: 2, spaceBetween: 10 },
                      768: { slidesPerView: 3, spaceBetween: 15 },
                      1024: { slidesPerView: 4, spaceBetween: 15 },
                      1200: { slidesPerView: 5, spaceBetween: 20 },
                    }}
                    navigation={{
                      prevEl: "#prev-top-movies",
                      nextEl: "#next-top-movies",
                    }}
                    loop={true}
                    slidesPerView={4}
                    spaceBetween={20}
                    // as="ul"
                    className="favorites-slider list-inline row p-0 m-0 iq-rtl-direction"
                  >
                    {trendingData.loading ? (
                      <div className="col-12 text-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                        <p className="text-white mt-2">Loading trending movies...</p>
                      </div>
                    ) : trendingData.error ? (
                      <div className="col-12 text-center">
                        <h3 className="text-white">Error Loading Trending Movies</h3>
                        <p className="text-white-50">{trendingData.error}</p>
                        <button
                          className="btn btn-primary mt-3"
                          onClick={fetchTrendingMovies}
                        >
                          Retry
                        </button>
                      </div>
                    ) : trendingData.movies && trendingData.movies.length > 0 ? (
                      trendingData.movies.slice(0, 10).map((item, index) => (
                        <SwiperSlide as="li" key={item._id}>
                          <div className=" block-images position-relative">
                            <div className="img-box">
                              <img
                                src={item?.imageUrl}
                                className="img-fluid"
                                style={{ height: '200px', width: '100%', objectFit: 'cover' }}
                                alt={item.title}
                                
                              />
                            </div>
                            <div className="block-description">
                              <h6 className="iq-title">
                                <Link to={`/movie-details/${item._id}`}>{item.title}</Link>
                              </h6>
                              <div className="movie-time d-flex align-items-center my-2 iq-ltr-direction">
                                <div className="badge badge-secondary p-1 mr-2">
                                  {item.ageRating}
                                </div>
                                <span className="text-white">
                                  {item.duration}
                                </span>
                              </div>
                              <div className="hover-buttons">
                                <Link
                                  to={`/movie-details/${item._id}`}
                                  role="button"
                                  className="btn btn-hover iq-button"
                                  onClick={handleLinkClick}
                                >
                                  <i
                                    className="fa fa-play mr-1"
                                    aria-hidden="true"
                                  ></i>
                                  Play Now
                                </Link>
                              </div>
                            </div>
                            <div className="block-social-info">
                              <ul className="list-inline p-0 m-0 music-play-lists">
                                <li className="share">
                                  <span>
                                    <i className="ri-share-fill"></i>
                                  </span>
                                  <div className="share-box">
                                    <div className="d-flex align-items-center">
                                      <a
                                        href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="share-ico"
                                        tabIndex="0"
                                      >
                                        <i className="ri-facebook-fill"></i>
                                      </a>
                                      <a
                                        href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="share-ico"
                                        tabIndex="0"
                                      >
                                        <i className="ri-twitter-fill"></i>
                                      </a>
                                      <a
                                        onClick={copyURL}
                                        data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                        className="share-ico iq-copy-link"
                                        tabIndex="0"
                                      >
                                        <i className="ri-links-fill"></i>
                                      </a>
                                    </div>
                                  </div>
                                </li>
                                <CompactWatchlistButtons item={{
                                  id: parseInt(item._id),
                                  title: item.title,
                                  type: item.media_type || 'movie',
                                  poster_path: item.imageUrl?.includes('tmdb.org') ? item.imageUrl.split('/').pop() : null,
                                  imgSrc: item.imageUrl,
                                  vote_average: item.vote_average,
                                  release_date: item.release_date,
                                  overview: item.description,
                                  adult: item.adult
                                }} />
                              </ul>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))
                    ) : (
                      <div className="col-12 text-center">
                        <p className="text-white">No trending movies available</p>
                      </div>
                    )}
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section id="iq-familiar-favorites">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between ">
                  <h4 className="main-title mb-3">Popular TV Shows</h4>
                  <Link className="iq-view-all" to="/view-all-tv/popular" onClick={handleLinkClick}>
                    View All
                  </Link>
                </div>
                <div id="favorites-contens">
                  <div
                    id="prev-family"
                    className="swiper-button swiper-button-prev"
                  >
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div
                    id="next-family"
                    className="swiper-button swiper-button-next"
                  >
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    breakpoints={{
                      320: { slidesPerView: 1, spaceBetween: 10 },
                      480: { slidesPerView: 2, spaceBetween: 10 },
                      768: { slidesPerView: 3, spaceBetween: 15 },
                      1024: { slidesPerView: 4, spaceBetween: 15 },
                      1200: { slidesPerView: 5, spaceBetween: 20 },
                    }}
                    navigation={{
                      prevEl: "#prev-family",
                      nextEl: "#next-family",
                    }}
                    loop={true}
                    slidesPerView={4}
                    spaceBetween={15}
                    as="ul"
                    className="favorites-slider list-inline row p-0 m-0 iq-rtl-direction"
                  >
                    {trendingData.loading ? (
                      <div className="col-12 text-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                        <p className="text-white mt-2">Loading popular TV shows...</p>
                      </div>
                    ) : trendingData.error ? (
                      <div className="col-12 text-center">
                        <h3 className="text-white">Error Loading Popular TV Shows</h3>
                        <p className="text-white-50">{trendingData.error}</p>
                        <button
                          className="btn btn-primary mt-3"
                          onClick={fetchTrendingMovies}
                        >
                          Retry
                        </button>
                      </div>
                    ) : trendingData.tvShows && trendingData.tvShows.length > 0 ? (
                      trendingData.tvShows.slice(0, 8).map((item) => (
                        <SwiperSlide as="li" key={item._id}>
                          <div className=" block-images position-relative">
                            <div className="img-box">
                              <img
                                src={item.imageUrl}
                                className="img-fluid"
                                style={{ height: '200px', width: '100%', objectFit: 'cover' }}
                                alt={item.title}
                                onError={(e) => {
                                  e.target.src = 'https://via.placeholder.com/300x450/333/fff?text=No+Image';
                                }}
                              />
                            </div>
                            <div className="block-description">
                              <h6 className="iq-title">
                                <Link to={`/movie-details/${item._id}`}>{item.title}</Link>
                              </h6>
                              <div className="movie-time d-flex align-items-center my-2 iq-ltr-direction">
                                <div className="badge badge-secondary p-1 mr-2">
                                  {item.ageRating}
                                </div>
                                <span className="text-white">
                                  {item.duration}
                                </span>
                              </div>
                              <div className="hover-buttons">
                                <Link
                                  to={`/movie-details/${item._id}`}
                                  role="button"
                                  className="btn btn-hover iq-button"
                                  onClick={handleLinkClick}
                                >
                                  <i
                                    className="fa fa-play mr-1"
                                    aria-hidden="true"
                                  ></i>
                                  Play Now
                                </Link>
                              </div>
                            </div>
                            <div className="block-social-info">
                              <ul className="list-inline p-0 m-0 music-play-lists">
                                <li className="share">
                                  <span>
                                    <i className="ri-share-fill"></i>
                                  </span>
                                  <div className="share-box">
                                    <div className="d-flex align-items-center">
                                      <a
                                        href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="share-ico"
                                        tabIndex="0"
                                      >
                                        <i className="ri-facebook-fill"></i>
                                      </a>
                                      <a
                                        href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="share-ico"
                                        tabIndex="0"
                                      >
                                        <i className="ri-twitter-fill"></i>
                                      </a>
                                      <a
                                        onClick={copyURL}
                                        className="share-ico iq-copy-link"
                                        tabIndex="0"
                                      >
                                        <i className="ri-links-fill"></i>
                                      </a>
                                    </div>
                                  </div>
                                </li>
                                <CompactWatchlistButtons item={{
                                  id: parseInt(item._id),
                                  title: item.title,
                                  type: item.media_type || 'movie',
                                  poster_path: item.imageUrl?.includes('tmdb.org') ? item.imageUrl.split('/').pop() : null,
                                  imgSrc: item.imageUrl,
                                  vote_average: item.vote_average,
                                  release_date: item.release_date,
                                  overview: item.description,
                                  adult: item.adult
                                }} />
                              </ul>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))
                    ) : (
                      <div className="col-12 text-center">
                        <p className="text-white">No popular TV shows available</p>
                      </div>
                    )}
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section id="iq-upcoming-movie">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between mt-3">
                  <h4 className="main-title">Upcoming Movies</h4>
                  <Link className="iq-view-all" to="/view-all-movies/upcoming" onClick={handleLinkClick}>
                    View All
                  </Link>
                </div>
                <div id="upcoming-contens">
                  <div id="prev1" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div id="next1" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    breakpoints={{
                      320: { slidesPerView: 1, spaceBetween: 10 },
                      480: { slidesPerView: 2, spaceBetween: 10 },
                      768: { slidesPerView: 3, spaceBetween: 15 },
                      1024: { slidesPerView: 4, spaceBetween: 15 },
                      1200: { slidesPerView: 5, spaceBetween: 20 },
                    }}
                    navigation={{
                      prevEl: "#prev1",
                      nextEl: "#next1",
                    }}
                    loop={true}
                    slidesPerView={4}
                    spaceBetween={15}
                    as="ul"
                    className="favorites-slider list-inline row p-0 m-0 iq-rtl-direction"
                  >
                    {upcomingMoviesSection.loading ? (
                      <div className="col-12 text-center d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                        <p className="text-white mt-3 ml-3">Loading upcoming movies...</p>
                      </div>
                    ) : upcomingMoviesSection.error ? (
                      <div className="col-12 text-center">
                        <p className="text-white">Error: {upcomingMoviesSection.error}</p>
                        <button
                          className="btn btn-primary mt-2"
                          onClick={fetchUpcomingMoviesSection}
                        >
                          Retry
                        </button>
                      </div>
                    ) : upcomingMoviesSection.movies && upcomingMoviesSection.movies.length > 0 ? (
                      upcomingMoviesSection.movies.slice(0, 10).map((item, index) => (
                        <SwiperSlide as="li" key={index}>
                          <div className=" block-images position-relative" >
                            <div className="img-box"  >
                              <img
                                src={item?.imageUrl}
                                className="img-fluid"
                                style={{ height: '200px', width: '100%', objectFit: 'cover' }}
                                alt={item?.title || "Movie"}
                              
                              />
                            </div>
                            <div className="block-description" >
                              <h6 className="iq-title">
                                <Link to="/show-details">{item?.title}</Link>
                              </h6>
                              <div className="movie-time d-flex align-items-center my-2 iq-ltr-direction">
                                <div className="badge badge-secondary p-1 mr-2">
                                  {item?.ageRating}
                                </div>
                                <span className="text-white">
                                  {item?.duration}
                                </span>
                              </div>
                              <div className="hover-buttons">
                                <Link
                                  to="/show-details"
                                  role="button"
                                  className="btn btn-hover iq-button"
                                  onClick={handleLinkClick}
                                >
                                  <i
                                    className="fa fa-play mr-1"
                                    aria-hidden="true"
                                  ></i>
                                  Play Now
                                </Link>
                              </div>
                            </div>
                            <div className="block-social-info">
                              <ul className="list-inline p-0 m-0 music-play-lists">
                                <li className="share">
                                  <span>
                                    <i className="ri-share-fill"></i>
                                  </span>
                                  <div className="share-box">
                                    <div className="d-flex align-items-center">
                                      <a
                                        href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="share-ico"
                                        tabIndex="0"
                                      >
                                        <i className="ri-facebook-fill"></i>
                                      </a>
                                      <a
                                        href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="share-ico"
                                        tabIndex="0"
                                      >
                                        <i className="ri-twitter-fill"></i>
                                      </a>
                                      <a
                                        onClick={copyURL}
                                        data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                        className="share-ico iq-copy-link"
                                        tabIndex="0"
                                      >
                                        <i className="ri-links-fill"></i>
                                      </a>
                                    </div>
                                  </div>
                                </li>
                                <CompactWatchlistButtons item={{
                                  id: parseInt(item._id),
                                  title: item.title,
                                  type: item.media_type || 'movie',
                                  poster_path: item.imageUrl?.includes('tmdb.org') ? item.imageUrl.split('/').pop() : null,
                                  imgSrc: item.imageUrl,
                                  vote_average: item.vote_average,
                                  release_date: item.release_date,
                                  overview: item.description,
                                  adult: item.adult
                                }} />
                              </ul>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))
                    ) : (
                      <div className="col-12 text-center">
                        <p className="text-white">No upcoming movies available</p>
                      </div>
                    )}
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section id="iq-suggestede" className="s-margin">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="main-title">Suggested For You</h4>
                  <Link className="iq-view-all" to="/view-all-movies/popular" onClick={handleLinkClick}>
                    View All
                  </Link>
                </div>
                <div id="suggestede-contens">
                  <div id="prev3" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div id="next3" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    slidesPerView={4}
                    spaceBetween={15}
                    navigation={{
                      prevEl: "#prev3",
                      nextEl: "#next3",
                    }}
                    breakpoints={{
                      320: { slidesPerView: 1, spaceBetween: 10 },
                      480: { slidesPerView: 2, spaceBetween: 10 },
                      768: { slidesPerView: 3, spaceBetween: 15 },
                      1024: { slidesPerView: 4, spaceBetween: 15 },
                      1200: { slidesPerView: 5, spaceBetween: 20 },
                    }}
                    loop={true}
                    as="ul"
                    className="list-inline favorites-slider row p-0 m-0 iq-rtl-direction"
                  >
                    {selectedTrending.loading ? (
                      <div className="col-12 text-center d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                        <p className="text-white mt-3 ml-3">Loading suggestions...</p>
                      </div>
                    ) : selectedTrending.error ? (
                      <div className="col-12 text-center">
                        <p className="text-white">Error: {selectedTrending.error}</p>
                        <button className="btn btn-primary mt-2" onClick={fetchSelectedTrending}>Retry</button>
                      </div>
                    ) : selectedTrending.movies && selectedTrending.movies.length > 0 ? (
                      selectedTrending.movies.map((item, index) => (
                        <SwiperSlide as="li" key={index}>
                          <div className=" block-images position-relative">
                            <div className="img-box "  >
                              <img
                                src={item?.image}
                                className="img-fluid"
                                // style={{ height: '200px', width: '100%', objectFit: 'cover' }}
                                alt={item?.title || ''}
                              />
                            </div>
                            <div className="block-description">
                              <h6 className="iq-title">
                                <Link to="/show-details">{item?.title}</Link>
                              </h6>
                              <div className="movie-time d-flex align-items-center my-2 iq-ltr-direction">
                                <div className="badge badge-secondary p-1 mr-2">
                                  {item?.ageRating}
                                </div>
                                <span className="text-white">
                                  {item?.duration}
                                </span>
                              </div>
                              <div className="hover-buttons">
                                <Link
                                  to="/show-details"
                                  role="button"
                                  className="btn btn-hover iq-button"
                                  onClick={handleLinkClick}
                                >
                                  <i className="fa fa-play mr-1" aria-hidden="true"></i>
                                  Play Now
                                </Link>
                              </div>
                            </div>
                            <div className="block-social-info">
                              <ul className="list-inline p-0 m-0 music-play-lists">
                                <li className="share">
                                  <span>
                                    <i className="ri-share-fill"></i>
                                  </span>
                                  <div className="share-box">
                                    <div className="d-flex align-items-center">
                                      <a href={`https://www.facebook.com/sharer?u=${window.location.href}`} target="_blank" rel="noopener noreferrer" className="share-ico" tabIndex="0">
                                        <i className="ri-facebook-fill"></i>
                                      </a>
                                      <a href={`https://twitter.com/intent/tweet?text=${encodeURIComponent('Check this out: ' + (item?.title || ''))}`} target="_blank" rel="noopener noreferrer" className="share-ico" tabIndex="0">
                                        <i className="ri-twitter-fill"></i>
                                      </a>
                                      <a onClick={copyURL} data-link={window.location.href} className="share-ico iq-copy-link" tabIndex="0">
                                        <i className="ri-links-fill"></i>
                                      </a>
                                    </div>
                                  </div>
                                </li>
                                <CompactWatchlistButtons item={{
                                  id: parseInt(item._id),
                                  title: item.title,
                                  type: item.media_type || 'movie',
                                  poster_path: item.imageUrl?.includes('tmdb.org') ? item.imageUrl.split('/').pop() : null,
                                  imgSrc: item.imageUrl,
                                  vote_average: item.vote_average,
                                  release_date: item.release_date,
                                  overview: item.description,
                                  adult: item.adult
                                }} />
                              </ul>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))
                    ) : (
                      <div className="col-12 text-center">
                        <p className="text-white">No suggestions available</p>
                      </div>
                    )}
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section id="parallex" className="parallax-window" style={{backgroundImage: `url(${latestMovie.movie?.poster_url || parallax3})`}}>
          <Container fluid className="h-100">
            <Row className="align-items-center justify-content-center h-100 parallaxt-details">
              <Col lg="4" className="r-mb-23">
                <div className="text-left">
                  {latestMovie.loading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{height: '400px'}}>
                      <div className="text-center">
                        <div className="spinner-border text-primary mb-3" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                        <h4 className="text-white">Loading Latest Movie...</h4>
                        <p className="text-white-50">Fetching data from TMDB</p>
                      </div>
                    </div>
                  ) : latestMovie.error ? (
                    <div className="d-flex justify-content-center align-items-center" style={{height: '400px'}}>
                      <div className="text-center">
                        <h4 className="text-white">Error Loading Movie</h4>
                        <p className="text-white-50">{latestMovie.error}</p>
                        <button 
                          className="btn btn-primary mt-3"
                          onClick={fetchLatestMovieData}
                        >
                          Retry
                        </button>
                      </div>
                    </div>
                  ) : latestMovie.movie ? (
                    <>
                      <Link to={`/movie-details/${latestMovie.movie?.id || ''}`}>
                        <img 
                          src={latestMovie.movie?.poster_url || parallax4} 
                          className="img-fluid" 
                          alt={latestMovie.movie?.title || 'Latest Movie'}
                          style={{maxHeight: '200px', objectFit: 'contain'}}
                        />
                      </Link>
                      <div className="parallax-ratting d-flex align-items-center mt-3 mb-3">
                        <ul className="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left">
                          {[...Array(5)].map((_, i) => (
                            <li key={i}>
                              <Link to="#" className={i === 0 ? "text-primary" : "pl-2 text-primary"}>
                                <i 
                                  className={
                                    i < Math.floor((latestMovie.movie?.vote_average || 0) / 2) 
                                      ? "fa fa-star" 
                                      : i < (latestMovie.movie?.vote_average || 0) / 2 
                                        ? "fa fa-star-half-o" 
                                        : "fa fa-star-o"
                                  } 
                                  aria-hidden="true"
                                ></i>
                              </Link>
                            </li>
                          ))}
                        </ul>
                        <span className="text-white ml-3">
                          {latestMovie.movie?.rating || '7.5'} (TMDB)
                        </span>
                      </div>
                      <div className="movie-time d-flex align-items-center mb-3 iq-ltr-direction">
                        <div className="badge badge-secondary mr-3">
                          {latestMovie.movie?.ageRating || '13+'}
                        </div>
                        <h6 className="text-white">{latestMovie.movie?.duration || '2h 30m'}</h6>
                        <span className="text-white ml-3">{latestMovie.movie?.year || new Date().getFullYear()}</span>
                      </div>
                      <p>
                        {latestMovie.movie?.overview || "No description available for this movie."}
                      </p>
                      <div className="parallax-buttons">
                        <Link 
                          to={`/movie-details/${latestMovie.movie?.id || ''}`} 
                          className="btn btn-hover" 
                          onClick={handleLinkClick}
                        >
                          Play Now
                        </Link>
                        <Link 
                          to={`/movie-details/${latestMovie.movie?.id || ''}`} 
                          className="btn btn-link" 
                          onClick={handleLinkClick}
                        >
                          More details
                        </Link>
                      </div>
                    </>
                  ) : (
                    <div className="d-flex justify-content-center align-items-center" style={{height: '400px'}}>
                      <div className="text-center">
                        <h4 className="text-white">No Movie Data</h4>
                        <p className="text-white-50">Unable to load latest movie information</p>
                        <button 
                          className="btn btn-primary mt-3"
                          onClick={fetchLatestMovieData}
                        >
                          Load Latest Movie
                        </button>
                        <div className="mt-3">
                          <button 
                            className="btn btn-secondary btn-sm mr-2"
                            onClick={() => {
                              console.log("🔍 Current latestMovie state:", latestMovie);
                              console.log("🔍 Testing API call...");
                              fetchLatestMovieData();
                            }}
                          >
                            Debug API Call
                          </button>
                          <button 
                            className="btn btn-success btn-sm"
                            onClick={() => {
                              console.log("🧪 Testing with sample data...");
                              const sampleMovie = {
                                id: 12345,
                                title: "Sample Latest Movie",
                                overview: "This is a sample movie to test the UI functionality. The movie features amazing visuals and an engaging storyline.",
                                release_date: "2024-01-15",
                                vote_average: 8.2,
                                vote_count: 1500,
                                adult: false,
                                backdrop_path: "/sample-backdrop.jpg",
                                poster_path: "/sample-poster.jpg",
                                runtime: 135,
                                genres: [28, 12, 16],
                                backdrop_url: parallax3,
                                poster_url: parallax4,
                                ageRating: '13+',
                                duration: '2h 15m',
                                year: '2024',
                                rating: '8.2'
                              };
                              setLatestMovie({
                                movie: sampleMovie,
                                loading: false,
                                error: null
                              });
                              console.log("✅ Sample movie data set:", sampleMovie);
                            }}
                          >
                            Test with Sample Data
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Col>
              <Col lg="8">
                <div className="parallax-img">
                  <Link to={latestMovie.movie ? `/movie-details/${latestMovie.movie.id}` : "/movie-details"}>
                    <img
                      src={latestMovie.movie ? latestMovie.movie.backdrop_url : parallax3}
                      className="img-fluid w-100"
                      alt={latestMovie.movie ? latestMovie.movie.title : "Latest Movie"}
                      style={{height: '500px', objectFit: 'cover'}}
                    />
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section id="iq-trending" className="s-margin" >
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="main-title">Trending TV Shows</h4>
                </div>
                <div id="trending-contens">
                  <div id="prev4" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div id="next4" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    as="ul"
                    thumbs={{ swiper: thumbsSwiper }}
                    centeredSlides={true}
                    centeredSlidesBounds={true}
                    navigation={{
                      prevEl: "#prev4",
                      nextEl: "#next4",
                    }}
                    slidesPerView={4}
                    spaceBetween={15}
                    breakpoints={{
                      320: { slidesPerView: 1, spaceBetween: 10 },
                      480: { slidesPerView: 2, spaceBetween: 10 },
                      768: { slidesPerView: 3, spaceBetween: 15 },
                      1024: { slidesPerView: 4, spaceBetween: 15 },
                      1200: { slidesPerView: 5, spaceBetween: 20 },
                    }}
                    loop={true}
                    onSwiper={setSwiperInstance}  // ADD THIS
                    onSlideChange={handleTrendingTVShowSelect}  // ADD THIS
                    className="list-inline p-0 m-0 row align-items-center iq-rtl-direction"
                  >
                    {trendingData.loading ? (
                      <div className="col-12 text-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                        <p className="text-white mt-2">Loading trending TV shows...</p>
                      </div>
                    ) : trendingData.error ? (
                      <div className="col-12 text-center">
                        <h3 className="text-white">Error Loading Trending TV Shows</h3>
                        <p className="text-white-50">{trendingData.error}</p>
                        <button
                          className="btn btn-primary mt-3"
                          onClick={fetchTrendingMovies}
                        >
                          Retry
                        </button>
                      </div>
                    ) : trendingData.tvShows && trendingData.tvShows.length > 0 ? (
                      trendingData.tvShows.slice(0, 6).map((item) => (
                        <SwiperSlide as="li" key={item._id}>
                          <div
                            className={`movie-slick position-relative ${selectedTrendingTVShow?._id === item._id ? 'selected-trending-tv-show' : ''}`}
                            onClick={() => handleTrendingTVShowSelect(item)}
                            style={{ cursor: 'pointer' }}
                          >
                            <img
                              src={item.imageUrl}
                              className="img-fluid"
                              style={{ height: '200px', width: '100%', objectFit: 'cover' }}
                              alt={item.title}
                              onError={(e) => {
                                e.target.src = 'https://via.placeholder.com/300x450/333/fff?text=No+Image';
                              }}
                            />
                          </div>
                        </SwiperSlide>
                      ))
                    ) : (
                      <div className="col-12 text-center">
                        <p className="text-white">No trending TV shows available</p>
                      </div>
                    )}
                  </Swiper>
                </div>
                <div>
                  <Swiper
                    onSwiper={setThumbsSwiper}
                    slidesPerView={1}
                    freeMode={true}
                    watchSlidesProgress={true}
                    id="trending-slider"
                    className="mt-3  list-inline p-0 m-0  d-flex align-items-center iq-rtl-direction"
                  >
                    <SwiperSlide as="li">
                      <div
                        className="tranding-block position-relative"
                        style={{
                          backgroundImage: `url(${selectedTrendingTVShow ? (selectedTrendingTVShow.imageUrl || trending1) : trending1})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundRepeat: 'no-repeat'
                        }}
                      >
                        <Tab.Container
                          defaultActiveKey="trending-data1"
                          activeKey={activeTrendingTab}
                          onSelect={(key) => setActiveTrendingTab(key)}
                          className="trending-custom-tab"
                        >
                          <div className="tab-title-info position-relative iq-ltr-direction">
                            <Nav
                              as="ul"
                              variant="pills"
                              className="trending-pills nav-pills d-flex justify-content-center align-items-center text-center iq-ltr-direction"
                            >
                              <Nav.Item as="li" className="nav-item">
                                <Nav.Link href="" eventKey="trending-data1">
                                  Overview
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item as="li" className="nav-item">
                                <Nav.Link href="" eventKey="trending-data2">
                                  Episodes
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item as="li" className="nav-item">
                                <Nav.Link href="" eventKey="trending-data3">
                                  Trailers
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item as="li" className="nav-item">
                                <Nav.Link href="" eventKey="trending-data4">
                                  Similar Like This
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                          </div>
                          <Tab.Content className="trending-content">
                            <Tab.Pane
                              eventKey="trending-data1"
                              className="overlay-tab show fade"
                            >
                              <div className="trending-info align-items-center w-100 animated fadeInUp iq-ltr-direction">
                                <Link to="#" tabIndex="0">
                                  <div className="res-logo">
                                    <div className="channel-logo">
                                      <img
                                        src={logo}
                                        className="c-logo"
                                        alt="copepod"
                                      />
                                    </div>
                                  </div>
                                </Link>
                                <h1 className="trending-text big-title text-uppercase">
                                  {selectedTrendingTVShow ? selectedTrendingTVShow.title : "the hero camp"}
                                </h1>
                                <div className="d-flex align-items-center text-white text-detail">
                                  <span className="badge badge-secondary p-3">
                                    {selectedTrendingTVShow ? (selectedTrendingTVShow.ageRating || "18+") : "18+"}
                                  </span>
                                  <span className="ml-3">{selectedTrendingTVShow ? (selectedTrendingTVShow.duration || "3 Seasons") : "3 Seasons"}</span>
                                  <span className="trending-year">{selectedTrendingTVShow ? (selectedTrendingTVShow.release_date?.substring(0, 4) || "2020") : "2020"}</span>
                                  {selectedTrendingTVShow?.vote_average && (
                                    <span className="ml-3 text-warning">⭐ {selectedTrendingTVShow.vote_average.toFixed(1)}</span>
                                  )}
                                </div>
                                <div className="d-flex align-items-center series mb-4">
                                  <Link to="#">
                                    <img
                                      src= {selectedTrendingTVShow ? selectedTrendingTVShow.imageUrl : "the hero camp"}
                                      className="img-fluid"
                                      style={{ height: '80px', width: '200%', objectFit: 'fill' }}
                                      alt=""
                                    />
                                  </Link>
                                  <span className="text-gold ml-3">
                                    {selectedTrendingTVShow ? `Selected: ${selectedTrendingTVShow.title}` : "#2 in Series Today"}
                                  </span>
                                </div>
                                <p className="trending-dec wrap">
                                  {selectedTrendingTVShow ? (selectedTrendingTVShow.description || selectedTrendingTVShow.overview || '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery. Through engaging characters and intense training sequences, the series explores themes of teamwork, self-discovery, and the responsibilities that come with extraordinary abilities.') : '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery. Through engaging characters and intense training sequences, the series explores themes of teamwork, self-discovery, and the responsibilities that come with extraordinary abilities.'}
                                </p>
                                <div className="p-btns">
                                  <div className="d-flex align-items-center p-0">
                                    <Link
                                      to="/show-details"
                                      className="btn btn-hover mr-2"
                                      tabIndex="0"
                                      onClick={handleLinkClick}
                                    >
                                      <i
                                        className="fa fa-play mr-2"
                                        aria-hidden="true"
                                      ></i>
                                      Play Now
                                    </Link>
                                    <Link
                                      to="#"
                                      className="btn btn-link"
                                      tabIndex="0"
                                    >
                                      <i className="ri-add-line"></i>My List
                                    </Link>
                                  </div>
                                </div>
                                <div className="trending-list mt-4">
                                  <div className="text-primary title">
                                    Starring:
                                    <span className="text-body">
                                      {selectedTrendingTVShow ? (selectedTrendingTVShow.cast || "Wagner Moura, Boyd Holbrook, Joanna") : "Wagner Moura, Boyd Holbrook, Joanna"}
                                    </span>
                                  </div>
                                  <div className="text-primary title">
                                    Genres:
                                    <span className="text-body">
                                      {selectedTrendingTVShow ? (selectedTrendingTVShow.genres || "Crime, Action, Thriller, Biography") : "Crime, Action, Thriller, Biography"}
                                    </span>
                                  </div>
                                  <div className="text-primary title">
                                    This Is:
                                    <span className="text-body">
                                      {selectedTrendingTVShow ? (selectedTrendingTVShow.contentRating || "Violent, Forceful") : "Violent, Forceful"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </Tab.Pane>
                            <Tab.Pane
                              eventKey="trending-data2"
                              className="overlay-tab  fade show "
                              id="trending-episode1"
                            >
                              <div className="trending-info align-items-center w-100 animated fadeInUp iq-ltr-direction">
                                <Link to="#" tabIndex="0">
                                  <div className="channel-logo">
                                    <img
                                      src={logo}
                                      className="c-logo"
                                      alt="stramit"
                                    />
                                  </div>
                                </Link>
                                <h1 className="trending-text big-title text-uppercase">
                                  {selectedTrendingTVShow ? selectedTrendingTVShow.title : "the hero camp"}
                                </h1>
                                <div className="d-flex align-items-center text-white text-detail mb-4">
                                  <span className="season_date ml-2">
                                    {selectedTrendingTVShow ? (selectedTrendingTVShow.duration || "2 Seasons") : "2 Seasons"}
                                  </span>
                                  <span className="trending-year">
                                    {selectedTrendingTVShow ? (selectedTrendingTVShow.release_date || "Feb 2019") : "Feb 2019"}
                                  </span>
                                </div>
                                <div className="iq-custom-select d-inline-block sea-epi">
                                  {/* <Select options={options1} id="f2" /> */}
                                </div>
                                <div
                                  className="episodes-contens mt-4"
                                  id="episode1"
                                >
                                  <div
                                    id="prev11"
                                    className="swiper-button swiper-button-prev"
                                  >
                                    <i className="fa fa-chevron-left"></i>
                                  </div>
                                  <div
                                    id="next11"
                                    className="swiper-button swiper-button-next"
                                  >
                                    <i className="fa fa-chevron-right"></i>
                                  </div>
                                  <Swiper
                                    spaceBetween={15}
                                    navigation={{
                                      prevEl: "#prev11",
                                      nextEl: "#next11",
                                    }}
                                    breakpoints={{
                                      320: { slidesPerView: 2, spaceBetween: 10 },
                                      480: { slidesPerView: 3, spaceBetween: 10 },
                                      768: { slidesPerView: 4, spaceBetween: 15 },
                                      1024: { slidesPerView: 5, spaceBetween: 15 },
                                      1200: { slidesPerView: 6, spaceBetween: 20 },
                                    }}
                                    loop={true}
                                    onSwiper={setSwiperInstance}  // ADD THIS
                                    onSlideChange={handleTrendingTVShowSelect}  // ADD THIS
                                    className="list-inline p-0 m-0 iq-rtl-direction"
                                  >
                                    <SwiperSlide className="e-item">
                                      <div className="block-image position-relative">
                                        <Link to="#">
                                          <img
                                            src={selectedTrendingTVShow ? (selectedTrendingTVShow.imageUrl || trending01) : trending01}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </Link>
                                        <div className="episode-play-info">
                                          <div className="episode-play">
                                            <Link
                                              to="/show-details"
                                              tabIndex="0"
                                            >
                                              <i className="ri-play-fill"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="episodes-description text-body">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Link to="#">Episode 1</Link>
                                          <span className="text-primary">
                                            2.25 m
                                          </span>
                                        </div>
                                        <p className="mb-0">
                                          {selectedTrendingTVShow ? (selectedTrendingTVShow.description || selectedTrendingTVShow.overview || '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.') : '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.'}
                                        </p>
                                      </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="e-item">
                                      <div className="block-image position-relative">
                                        <Link to="#">
                                          <img
                                            src={selectedTrendingTVShow ? (selectedTrendingTVShow.imageUrl || trending01) : trending01}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </Link>
                                        <div className="episode-play-info">
                                          <div className="episode-play">
                                            <Link
                                              to="/show-details"
                                              tabIndex="0"
                                            >
                                              <i className="ri-play-fill"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="episodes-description text-body ">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Link to="#">Episode 2</Link>
                                          <span className="text-primary">
                                            3.23 m
                                          </span>
                                        </div>
                                        <p className="mb-0">
                                          {selectedTrendingTVShow ? (selectedTrendingTVShow.description || selectedTrendingTVShow.overview || '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.') : '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.'}
                                        </p>
                                      </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="e-item">
                                      <div className="block-image position-relative">
                                        <Link to="#">
                                          <img
                                            src={selectedTrendingTVShow ? (selectedTrendingTVShow.imageUrl || trending01) : trending01}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </Link>
                                        <div className="episode-play-info">
                                          <div className="episode-play">
                                            <Link
                                              to="/show-details"
                                              tabIndex="0"
                                            >
                                              <i className="ri-play-fill"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="episodes-description text-body">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Link to="#">Episode 3</Link>
                                          <span className="text-primary">
                                            2 m
                                          </span>
                                        </div>
                                        <p className="mb-0">
                                          {selectedTrendingTVShow ? (selectedTrendingTVShow.description || selectedTrendingTVShow.overview || '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.') : '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.'}
                                        </p>
                                      </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="e-item">
                                      <div className="block-image position-relative">
                                        <Link to="#">
                                          <img
                                            src={selectedTrendingTVShow ? (selectedTrendingTVShow.imageUrl || trending01) : trending01}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </Link>
                                        <div className="episode-play-info">
                                          <div className="episode-play">
                                            <Link
                                              to="/show-details"
                                              tabIndex="0"
                                            >
                                              <i className="ri-play-fill"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="episodes-description text-body ">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Link to="#">Episode 4</Link>
                                          <span className="text-primary">
                                            1.12 m
                                          </span>
                                        </div>
                                        <p className="mb-0">
                                          {selectedTrendingTVShow ? (selectedTrendingTVShow.description || selectedTrendingTVShow.overview || '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.') : '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.'}
                                        </p>
                                      </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="e-item">
                                      <div className="block-image position-relative">
                                        <Link to="#">
                                          <img
                                            src={selectedTrendingTVShow ? (selectedTrendingTVShow.imageUrl || trending01) : trending01}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </Link>
                                        <div className="episode-play-info">
                                          <div className="episode-play">
                                            <Link
                                              to="/show-details"
                                              tabIndex="0"
                                            >
                                              <i className="ri-play-fill"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="episodes-description text-body">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Link to="#">Episode 5</Link>
                                          <span className="text-primary">
                                            2.54 m
                                          </span>
                                        </div>
                                        <p className="mb-0">
                                          {selectedTrendingTVShow ? (selectedTrendingTVShow.description || selectedTrendingTVShow.overview || '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.') : '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.'}
                                        </p>
                                      </div>
                                    </SwiperSlide>
                                  </Swiper>
                                </div>
                              </div>
                            </Tab.Pane>
                            <Tab.Pane
                              eventKey="trending-data3"
                              className="overlay-tab fade show"
                            >
                              <div className="trending-info align-items-center w-100 animated fadeInUp iq-ltr-direction">
                                <Link to="#" tabIndex="0">
                                  <div className="channel-logo">
                                    <img
                                      src={logo}
                                      className="c-logo"
                                      alt="stramit"
                                    />
                                  </div>
                                </Link>
                                <h1 className="trending-text big-title text-uppercase">
                                  {selectedTrendingTVShow ? selectedTrendingTVShow.title : "the hero camp"}
                                </h1>
                                <div
                                  className="episodes-contens mt-4"
                                  id="episode2"
                                >
                                  <div
                                    id="prev12"
                                    className="swiper-button swiper-button-prev"
                                  >
                                    <i className="fa fa-chevron-left"></i>
                                  </div>
                                  <div
                                    id="next12"
                                    className="swiper-button swiper-button-next"
                                  >
                                    <i className="fa fa-chevron-right"></i>
                                  </div>
                                  <Swiper
                                    spaceBetween={15}
                                    navigation={{
                                      prevEl: "#prev12",
                                      nextEl: "#next12",
                                    }}
                                    loop={true}
                                    breakpoints={{
                                      320: { slidesPerView: 1 },
                                      550: { slidesPerView: 2 },
                                      991: { slidesPerView: 3 },
                                      1400: { slidesPerView: 4 },
                                    }}
                                    className="list-inline p-0 m-0 iq-rtl-direction"
                                  >
                                    <SwiperSlide className="e-item">
                                      <div className="block-image position-relative">
                                        <Link to="#" target="_blank">
                                          <img
                                            src={trending01}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </Link>
                                        <div className="episode-play-info">
                                          <div className="episode-play">
                                            <Link
                                              to="/show-details"
                                              target="_blank"
                                              tabIndex="0"
                                            >
                                              <i className="ri-play-fill"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="episodes-description text-body">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Link to="#" target="_blank">
                                            Trailer 1
                                          </Link>
                                          <span className="text-primary">
                                            2.25 m
                                          </span>
                                        </div>
                                        <p className="mb-0">
                                          {selectedTrendingTVShow ? (selectedTrendingTVShow.description || selectedTrendingTVShow.overview || '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.') : '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.'}
                                        </p>
                                      </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="e-item">
                                      <div className="block-image position-relative">
                                        <Link to="#" target="_blank">
                                          <img
                                             src= {selectedTrendingTVShow ? selectedTrendingTVShow.imageUrl : "the hero camp"}
                                             className="img-fluid"
                                            //  style={{ height: '400px',  objectFit: 'cover' }}
                                          />
                                        </Link>
                                        <div className="episode-play-info">
                                          <div className="episode-play">
                                            <Link
                                              to="/show-details"
                                              target="_blank"
                                              tabIndex="0"
                                            >
                                              <i className="ri-play-fill"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="episodes-description text-body">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Link to="#" target="_blank">
                                            Trailer 2
                                          </Link>
                                          <span className="text-primary">
                                            3.23 m
                                          </span>
                                        </div>
                                        <p className="mb-0">
                                          {selectedTrendingTVShow ? (selectedTrendingTVShow.description || selectedTrendingTVShow.overview || '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.') : '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.'}
                                        </p>
                                      </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="e-item">
                                      <div className="block-image position-relative">
                                        <Link to="#" target="_blank">
                                          <img
                                            src={trending01}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </Link>
                                        <div className="episode-play-info">
                                          <div className="episode-play">
                                            <Link
                                              to="/show-details"
                                              target="_blank"
                                              tabIndex="0"
                                            >
                                              <i className="ri-play-fill"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="episodes-description text-body">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Link to="#" target="_blank">
                                            Trailer 3
                                          </Link>
                                          <span className="text-primary">
                                            2 m
                                          </span>
                                        </div>
                                        <p className="mb-0">
                                          {selectedTrendingTVShow ? (selectedTrendingTVShow.description || selectedTrendingTVShow.overview || '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.') : '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.'}
                                        </p>
                                      </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="e-item">
                                      <div className="block-image position-relative">
                                        <Link to="#" target="_blank">
                                          <img
                                            src={trending01}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </Link>
                                        <div className="episode-play-info">
                                          <div className="episode-play">
                                            <Link
                                              to="/show-details"
                                              target="_blank"
                                              tabIndex="0"
                                            >
                                              <i className="ri-play-fill"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="episodes-description text-body">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Link to="#" target="_blank">
                                            Trailer 4
                                          </Link>
                                          <span className="text-primary">
                                            1.12 m
                                          </span>
                                        </div>
                                        <p className="mb-0">
                                          {selectedTrendingTVShow ? (selectedTrendingTVShow.description || selectedTrendingTVShow.overview || '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.') : '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.'}
                                        </p>
                                      </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="e-item">
                                      <div className="block-image position-relative">
                                        <Link to="#" target="_blank">
                                          <img
                                            src={trending01}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </Link>
                                        <div className="episode-play-info">
                                          <div className="episode-play">
                                            <Link
                                              to="/show-details"
                                              target="_blank"
                                              tabIndex="0"
                                            >
                                              <i className="ri-play-fill"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="episodes-description text-body">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Link to="#" target="_blank">
                                            Trailer 5
                                          </Link>
                                          <span className="text-primary">
                                            2.54 m
                                          </span>
                                        </div>
                                        <p className="mb-0">
                                          {selectedTrendingTVShow ? (selectedTrendingTVShow.description || selectedTrendingTVShow.overview || '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.') : '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.'}
                                        </p>
                                      </div>
                                    </SwiperSlide>
                                  </Swiper>
                                </div>
                              </div>
                            </Tab.Pane>
                            <Tab.Pane
                              eventKey="trending-data4"
                              className="overlay-tab fade show"
                            >
                              <div className="trending-info align-items-center w-100 animated fadeInUp iq-ltr-direction">
                                <Link to="#" tabIndex="0">
                                  <div className="channel-logo">
                                    <img
                                      src={logo}
                                      className="c-logo"
                                      alt="stramit"
                                    />
                                  </div>
                                </Link>
                                <h1 className="trending-text big-title text-uppercase">
                                  {selectedTrendingTVShow ? selectedTrendingTVShow.title : "the hero camp"}
                                </h1>
                                <div
                                  className="episodes-contens mt-4"
                                  id="episode3"
                                >
                                  <div
                                    id="prev13"
                                    className="swiper-button swiper-button-prev"
                                  >
                                    <i className="ri-arrow-left-s-line"></i>
                                  </div>
                                  <div
                                    id="next13"
                                    className="swiper-button swiper-button-next"
                                  >
                                    <i className="ri-arrow-right-s-line"></i>
                                  </div>
                                  <Swiper
                                    slidesPerView={4}
                                    spaceBetween={15}
                                    navigation={{
                                      prevEl: "#prev13",
                                      nextEl: "#next13",
                                    }}
                                    loop={true}
                                    breakpoints={{
                                      320: { slidesPerView: 1 },
                                      550: { slidesPerView: 2 },
                                      991: { slidesPerView: 3 },
                                      1400: { slidesPerView: 4 },
                                    }}
                                    className="list-inline p-0 m-0 iq-rtl-direction"
                                  >
                                    <SwiperSlide className="e-item">
                                      <div className="block-image position-relative">
                                        <Link to="#">
                                          <img
                                            src={selectedTrendingTVShow ? (selectedTrendingTVShow.imageUrl || trending01) : trending01}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </Link>
                                        <div className="episode-play-info">
                                          <div className="episode-play">
                                            <Link
                                              to="/show-details"
                                              tabIndex="0"
                                            >
                                              <i className="ri-play-fill"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="episodes-description text-body">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Link to="#">Episode 1</Link>
                                          <span className="text-primary">
                                            2.25 m
                                          </span>
                                        </div>
                                        <p className="mb-0">
                                          {selectedTrendingTVShow ? (selectedTrendingTVShow.description || selectedTrendingTVShow.overview || '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.') : '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.'}
                                        </p>
                                      </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="e-item">
                                      <div className="block-image position-relative">
                                        <Link to="#">
                                          <img
                                            src={selectedTrendingTVShow ? (selectedTrendingTVShow.imageUrl || trending01) : trending01}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </Link>
                                        <div className="episode-play-info">
                                          <div className="episode-play">
                                            <Link
                                              to="/show-details"
                                              tabIndex="0"
                                            >
                                              <i className="ri-play-fill"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="episodes-description text-body">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Link to="#">Episode 2</Link>
                                          <span className="text-primary">
                                            3.23 m
                                          </span>
                                        </div>
                                        <p className="mb-0">
                                          {selectedTrendingTVShow ? (selectedTrendingTVShow.description || selectedTrendingTVShow.overview || '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.') : '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.'}
                                        </p>
                                      </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="e-item">
                                      <div className="block-image position-relative">
                                        <Link to="#">
                                          <img
                                            src={selectedTrendingTVShow ? (selectedTrendingTVShow.imageUrl || trending01) : trending01}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </Link>
                                        <div className="episode-play-info">
                                          <div className="episode-play">
                                            <Link
                                              to="/show-details"
                                              tabIndex="0"
                                            >
                                              <i className="ri-play-fill"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="episodes-description text-body">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Link to="#">Episode 3</Link>
                                          <span className="text-primary">
                                            2 m
                                          </span>
                                        </div>
                                        <p className="mb-0">
                                          {selectedTrendingTVShow ? (selectedTrendingTVShow.description || selectedTrendingTVShow.overview || '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.') : '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.'}
                                        </p>
                                      </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="e-item">
                                      <div className="block-image position-relative">
                                        <Link to="#">
                                          <img
                                            src={selectedTrendingTVShow ? (selectedTrendingTVShow.imageUrl || trending01) : trending01}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </Link>
                                        <div className="episode-play-info">
                                          <div className="episode-play">
                                            <Link
                                              to="/show-details"
                                              tabIndex="0"
                                            >
                                              <i className="ri-play-fill"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="episodes-description text-body">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Link to="#">Episode 4</Link>
                                          <span className="text-primary">
                                            1.12 m
                                          </span>
                                        </div>
                                        <p className="mb-0">
                                          {selectedTrendingTVShow ? (selectedTrendingTVShow.description || selectedTrendingTVShow.overview || '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.') : '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.'}
                                        </p>
                                      </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="e-item">
                                      <div className="block-image position-relative">
                                        <Link to="#">
                                          <img
                                            src={selectedTrendingTVShow ? (selectedTrendingTVShow.imageUrl || trending01) : trending01}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </Link>
                                        <div className="episode-play-info">
                                          <div className="episode-play">
                                            <Link
                                              to="/show-details"
                                              tabIndex="0"
                                            >
                                              <i className="ri-play-fill"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="episodes-description text-body">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Link to="#">Episode 5</Link>
                                          <span className="text-primary">
                                            2.54 m
                                          </span>
                                        </div>
                                        <p className="mb-0">
                                          {selectedTrendingTVShow ? (selectedTrendingTVShow.description || selectedTrendingTVShow.overview || '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.') : '"Hero Camp" captivates audiences with its thrilling mix of superpowered action, coming-of-age drama, and mystery.'}
                                        </p>
                                      </div>
                                    </SwiperSlide>
                                  </Swiper>
                                </div>
                              </div>
                            </Tab.Pane>
                          </Tab.Content>
                        </Tab.Container>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>

      {/* CSS Styles for Trending TV Show Selection */}
      <style jsx>{`
        .selected-trending-tv-show {
          border: 3px solid #007bff !important;
          border-radius: 8px;
          box-shadow: 0 0 15px rgba(0, 123, 255, 0.5);
          transform: scale(1.05);
          transition: all 0.3s ease;
        }
        .selected-trending-tv-show img {
          border-radius: 5px;
        }
      `}</style>
    </>
  );
};

export default Homepage;
